import 'angular';

import contactMenuDirective from './contact-menu';

const MODULE_NAME = 'daupler.incidents.components.buttons.users';

var app = angular.module(MODULE_NAME, []);
app.directive('contactUserMenu', contactMenuDirective);
app.config(function($compileProvider) {
	'ngInject';
	$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|sms|tel):/);
});

export default MODULE_NAME;
